module.exports = __webpack_public_path__ + "img/img.8c0bf4f3.png";